module.exports = __webpack_public_path__ + "static/media/image_icon.669a5bee.svg";